var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"reset-button",class:{ rotating: _vm.isRotating },attrs:{"title":"Reset to original"},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"fa fa-undo"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecce4344","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Buttons/ResetIconButton.vue
// module id = Gawq
// module chunks = 1